import { z } from 'zod';

// Base Fetcher schema
export const FetcherDTO = z.object({
  name: z.string(),
  inherited: z.boolean(),
  like_parent: z.boolean(),
  arguments: z.record(z.string(), z.any()),
});

// UpdateFetcher schema (picks specific fields)
export const UpdateFetcherDTO = FetcherDTO.pick({
  name: true,
  arguments: true,
  like_parent: true,
});

// FetcherListItem schema
export const FetcherListItemDTO = z.object({
  name: z.string(),
  display_name: z.string(),
});

// TypeScript type inference
export type Fetcher = z.infer<typeof FetcherDTO>;
export type UpdateFetcher = z.infer<typeof UpdateFetcherDTO>;
export type FetcherListItem = z.infer<typeof FetcherListItemDTO>;